export default __webpack_public_path__ + "static/media/Gilroy-RegularItalic.cd8c71a8.woff";